import React, { useRef, useState } from "react";
import "./Contact.css";
import emailjs from "@emailjs/browser";
import {
  HiMail,
  HiPhone,
  HiLocationMarker,
  HiPaperAirplane,
  HiCheckCircle,
  HiClipboardCopy,
  HiCheck,
} from "react-icons/hi";
import { BsLinkedin, BsGithub } from "react-icons/bs";

const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState("idle"); // idle | sending | success | error
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText("abhinavpathak9984@gmail.com");
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus("sending");

    emailjs
      .sendForm(
        "service_gdzgfbt",
        "template_aod0zus",
        form.current,
        "RuCs-nsfWQM34RERx"
      )
      .then(
        () => {
          setStatus("success");
          e.target.reset();
          setTimeout(() => setStatus("idle"), 5000);
        },
        () => {
          setStatus("error");
          setTimeout(() => setStatus("idle"), 4000);
        }
      );
  };

  return (
    <section className="contact" id="contact">
      <h2 className="section-title">
        Get In <span>Touch</span>
      </h2>

      <div className="contact-inner">
        {/* Left — info */}
        <div className="contact-info">
          <h3 className="contact-info-title">
            Let's work <span>together</span>
          </h3>
          <p className="contact-info-desc">
            I'm currently open to new opportunities. Whether you have a project in mind, 
            a role to discuss, or simply want to connect, please don't hesitate to get 
            in touch. I'd love to hear from you and explore how we can work together
          </p>

          <div className="contact-details">
            <div className="contact-detail-item">
              <div className="contact-detail-icon">
                <HiMail />
              </div>
              <div className="contact-detail-text">
                <span className="contact-detail-label">Email</span>
                <div className="contact-email-row">
                  <a
                    href="mailto:abhinavpathak9984@gmail.com"
                    className="contact-detail-value contact-detail-link"
                  >
                    abhinavpathak9984@gmail.com
                  </a>
                  <button
                    type="button"
                    className={`copy-email-btn ${copied ? "copied" : ""}`}
                    onClick={handleCopyEmail}
                    title="Copy Email to Clipboard"
                  >
                    {copied ? <HiCheck /> : <HiClipboardCopy />}
                    {copied ? "Copied!" : "Copy"}
                  </button>
                </div>
              </div>
            </div>

            <div className="contact-detail-item">
              <div className="contact-detail-icon">
                <HiPhone />
              </div>
              <div className="contact-detail-text">
                <span className="contact-detail-label">Phone</span>
                <a
                  href="tel:+919682906846"
                  className="contact-detail-value contact-detail-link"
                >
                  +91-9682906846
                </a>
              </div>
            </div>

            <div className="contact-detail-item">
              <div className="contact-detail-icon">
                <HiLocationMarker />
              </div>
              <div className="contact-detail-text">
                <span className="contact-detail-label">Location</span>
                <span className="contact-detail-value">India</span>
              </div>
            </div>
          </div>

          {/* Social links */}
          <div className="contact-socials">
            <p className="contact-socials-label">Find me on</p>
            <div className="contact-socials-row">
              <a
                href="https://www.linkedin.com/in/abhinav9984"
                target="_blank"
                rel="noreferrer"
                className="contact-social-btn"
              >
                <BsLinkedin />
                LinkedIn
              </a>
              <a
                href="https://github.com/Abhinav4005"
                target="_blank"
                rel="noreferrer"
                className="contact-social-btn"
              >
                <BsGithub />
                GitHub
              </a>
            </div>
          </div>
        </div>

        {/* Right — form */}
        <div className="contact-form-wrap">
          {status === "success" ? (
            <div className="contact-success">
              <div className="contact-success-icon">
                <HiCheckCircle />
              </div>
              <h4 className="contact-success-title">Message Sent!</h4>
              <p className="contact-success-desc">
                Thanks for reaching out. I'll get back to you within 24 hours.
              </p>
            </div>
          ) : (
            <form className="form" ref={form} onSubmit={sendEmail}>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Full Name</label>
                  <input
                    placeholder="John Doe"
                    className="contact-input"
                    required
                    type="text"
                    name="user_name"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <input
                    placeholder="john@example.com"
                    className="contact-input"
                    required
                    type="email"
                    name="user_email"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Phone (optional)</label>
                  <input
                    placeholder="+91 XXXXX XXXXX"
                    className="contact-input"
                    type="number"
                    name="user_number"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Subject</label>
                  <input
                    placeholder="Project Inquiry"
                    className="contact-input"
                    required
                    type="text"
                    name="subject"
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea
                  className="contact-textarea"
                  placeholder="Tell me about your project..."
                  name="message"
                  required
                />
              </div>

              {status === "error" && (
                <p className="contact-error">
                  Something went wrong. Please try again or email me directly.
                </p>
              )}

              <div className="send-butn">
                <button
                  type="submit"
                  className="send"
                  disabled={status === "sending"}
                >
                  {status === "sending" ? (
                    <>
                      <span className="send-spinner" />
                      Sending...
                    </>
                  ) : (
                    <>
                      <HiPaperAirplane />
                      Send Message
                    </>
                  )}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;
